import { navigate } from 'gatsby'
import clsx from 'clsx'
import { ProductStatus } from 'lib/graphql/storeadmin'
import { ColumnsType, Image, Table, TableProps, Tag } from 'components/common'

export interface Product {
  key: string
  title: string
  status: ProductStatus
  optionNames?: string[]
  variantsRange?: number
  approvalRequired: boolean
  createdAt: string
  updatedAt: string
}

type InternalProps = TableProps<Product>
type Actions = Pick<InternalProps, 'onChange' | 'onRow'>
// TODO: Phase 1 ではコメントアウト
// type RowSelection = InternalProps['rowSelection']
export interface RatesTableProps
  extends Omit<
    InternalProps,
    'pagination' | 'columns' | 'sticky' | 'onChange' | 'onRow'
  > {
  dataSource: Array<Product>
}

const columns: ColumnsType<Product> = [
  {
    key: 'image',
    dataIndex: 'image',
    width: '100px',
    align: 'center',
    render: (value) => (
      <Image height={'40px'} src={value?.src ? value?.src : 'error'} />
    ),
  },
  {
    key: 'title',
    title: '施設名',
    dataIndex: 'title',
    ellipsis: true,
  },
  {
    key: 'status',
    title: 'ステータス',
    dataIndex: 'status',
    render: (value) => {
      switch (value) {
        case ProductStatus.Active:
          return <Tag color={'success'}>アクティブ</Tag>
        case ProductStatus.Draft:
          return <Tag color={'error'}>下書き</Tag>
        case ProductStatus.Inactive:
          return <Tag color={'error'}>非アクティブ</Tag>
        case ProductStatus.Archived:
          return <Tag color={'gray'}>アーカイブ</Tag>
        default:
          return null
      }
    },
  },
  {
    key: 'variantsRange',
    title: 'バリエーション',
    dataIndex: 'variantsRange',
    render: (value) => {
      return value ? `${value} 個のバリエーション` : ''
    },
  },
  {
    key: 'approvalRequired',
    title: '認証の要否',
    dataIndex: 'approvalRequired',
    render: (value) => {
      return value ? '必要' : <p className={clsx('text-gray-400')}>不要</p>
    },
  },
  {
    key: 'createdAt',
    title: '作成日時',
    dataIndex: 'createdAt',
  },
  {
    key: 'updatedAt',
    title: '更新日時',
    dataIndex: 'updatedAt',
  },
]

export const ProductTable = ({
  dataSource,
  ...restProps
}: RatesTableProps): JSX.Element => {
  // 現時点では使い道がないのでコメントアウト
  // const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>()
  // const rowSelection: RowSelection = {
  //   selectedRowKeys,
  //   onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
  // }

  const onChange: Actions['onChange'] = (
    pagination,
    filters,
    sorter,
    { currentDataSource, action }
  ) => {
    return
  }

  const onRow: Actions['onRow'] = (record, action) => {
    return {
      onClick: async (event) => {
        await navigate(`./${record.key}`)
      },
      // onDoubleClick: (event) => {},
      // onContextMenu: (event) => {},
      // onMouseEnter: (event) => {},
      // onMouseLeave: (event) => {},
    }
  }

  return (
    <>
      <Table<Product>
        sticky
        pagination={false}
        rowClassName={clsx('cursor-pointer')}
        // rowSelection={rowSelection}
        dataSource={dataSource}
        columns={columns}
        onChange={onChange}
        onRow={onRow}
        {...restProps}
      />
    </>
  )
}
